import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { CheckCircle2, Lock, Zap, ShieldCheck, Star, CreditCard } from 'lucide-react';
interface OfferBlockProps {
  variant: 'base' | 'premium';
}
const baseFeatures = ['75 Diseños Profesionales', 'Configuraciones Funcionales', 'Sistemas de Circulación', 'Corrales Modernos', 'Distribución Inteligente', 'Acceso inmediato'];
const bonusList = ['BONUS 1 — Sistemas de Circulación Inteligente', 'BONUS 2 — Guía de Distribución Funcional', 'BONUS 3 — Sistemas Modernos de Manejo Ganadero', 'BONUS 4 — Diseños Adaptables para Diferentes Producciones'];
const premiumExtras = ['Cómo reducir el estrés animal', 'Organización inteligente del trabajo rural', 'Circulación eficiente del ganado', 'Optimización de tiempos y manejo', 'Seguridad y trabajo práctico', 'Sistemas modernos de manejo ganadero', 'Materiales y mantenimiento rural', 'Estrategias para mejorar productividad'];
const MercadoPagoBadge = () => <div className="flex items-center justify-center gap-1.5 mt-2.5" data-id="element-191">
    <CreditCard className="w-3.5 h-3.5 text-brand-greenLight" data-id="element-192" />
    <span className="text-[10px] md:text-xs font-bold text-zinc-300" data-id="element-193">
      Pagás con
    </span>
    <span className="text-[10px] md:text-xs font-black bg-[#00b1ea] text-white px-1.5 py-0.5 rounded" data-id="element-194">
      Mercado Pago
    </span>
  </div>;
export function OfferBlock({
  variant
}: OfferBlockProps) {
  if (variant === 'base') {
    return <div className="bg-zinc-900 rounded-xl border-2 border-brand-green/50 shadow-2xl overflow-hidden flex flex-col h-full" data-id="element-195">
        <div className="bg-brand-green text-white p-4 md:p-5 text-center" data-id="element-196">
          <p className="text-[10px] md:text-xs font-bold uppercase tracking-widest opacity-90 mb-0.5" data-id="element-197">
            ✅ Opción Base
          </p>
          <h3 className="text-base md:text-xl font-display font-bold uppercase leading-tight" data-id="element-198">
            Sistema Pro Corrales Ganaderos™
          </h3>
          <p className="text-xs md:text-sm mt-1 font-semibold" data-id="element-199">
            Todo lo que necesitás para mejorar tu manejo ganadero
          </p>
        </div>

        <div className="p-4 md:p-5 flex flex-col flex-grow" data-id="element-200">
          <ul className="space-y-1.5 mb-3.5" data-id="element-201">
            {baseFeatures.map((f, i) => <li key={i} className="flex items-start gap-2" data-id="element-202">
                <CheckCircle2 className="w-4 h-4 text-brand-greenLight shrink-0 mt-0.5" data-id="element-203" />
                <span className="text-xs md:text-sm text-white font-semibold" data-id="element-204">
                  {f}
                </span>
              </li>)}
          </ul>

          <div className="bg-zinc-950 border border-brand-green/40 rounded-lg p-3 mb-4" data-id="element-205">
            <p className="font-display font-bold text-brand-greenLight uppercase text-xs mb-1.5" data-id="element-206">
              🎁 Incluye los 4 Bonus Especiales
            </p>
            <ul className="space-y-1" data-id="element-207">
              {bonusList.map((b, i) => <li key={i} className="flex items-start gap-1.5 text-[11px] md:text-xs text-zinc-300" data-id="element-208">
                  <span className="text-brand-greenLight font-bold" data-id="element-209">✔</span>
                  <span data-id="element-210">{b}</span>
                </li>)}
            </ul>
          </div>

          <div className="text-center mb-3 mt-auto" data-id="element-211">
            <p className="text-[10px] md:text-xs text-zinc-400 font-bold uppercase mb-0.5" data-id="element-212">
              🔥 Precio especial
            </p>
            <p className="text-3xl md:text-4xl font-display font-bold text-brand-greenLight" data-id="element-213">
              ARS $19.990
            </p>
            <p className="text-[10px] md:text-xs text-zinc-400 mt-0.5" data-id="element-214">
              Pago único · Sin suscripciones · Acceso inmediato
            </p>
          </div>

          <Button href="https://checkout.kitonline.shop/cart/48047343304942:1" pulse={false} className="text-xs md:text-sm py-2.5" data-id="element-215">
            🚀 SÍ, QUIERO EL SISTEMA
          </Button>

          <MercadoPagoBadge data-id="element-216" />

          <div className="flex flex-wrap justify-center gap-2 mt-3 text-[9px] md:text-[10px] text-zinc-400 font-semibold" data-id="element-217">
            <span className="flex items-center gap-0.5" data-id="element-218">
              <Lock className="w-3 h-3 text-brand-greenLight" data-id="element-219" />
              Pago seguro
            </span>
            <span className="flex items-center gap-0.5" data-id="element-220">
              <Zap className="w-3 h-3 text-brand-greenLight" data-id="element-221" />
              Acceso inmediato
            </span>
            <span className="flex items-center gap-0.5" data-id="element-222">
              <ShieldCheck className="w-3 h-3 text-brand-greenLight" data-id="element-223" />
              Garantía 7 días
            </span>
          </div>
        </div>
      </div>;
  }
  // Premium
  return <div className="bg-zinc-900 rounded-xl border-2 border-brand-green shadow-2xl overflow-hidden flex flex-col h-full relative md:-translate-y-2 glow-green" data-id="element-224">
      <div className="absolute top-0 right-0 bg-brand-yellow text-brand-ink font-display font-bold px-3 py-1 text-[10px] md:text-xs uppercase tracking-wider border-l-2 border-b-2 border-brand-ink flex items-center gap-1 z-10" data-id="element-225">
        <Star className="w-3 h-3 fill-current" data-id="element-226" /> Más Elegido
      </div>

      <div className="bg-gradient-to-br from-brand-greenDark to-brand-green text-white p-4 md:p-5 text-center" data-id="element-227">
        <p className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-brand-yellow mb-0.5" data-id="element-228">
          🏅 Elección de los Productores
        </p>
        <h3 className="text-base md:text-xl font-display font-bold uppercase leading-tight" data-id="element-229">
          Pack Premium
        </h3>
        <p className="text-xs md:text-sm mt-1 font-semibold" data-id="element-230">
          Para quienes quieren llevar su manejo ganadero a otro nivel
        </p>
      </div>

      <div className="p-4 md:p-5 flex flex-col flex-grow" data-id="element-231">
        <p className="font-display font-bold text-white text-sm md:text-base mb-2 uppercase" data-id="element-232">
          Todo lo anterior, más:
        </p>

        <div className="bg-zinc-950 border-2 border-brand-green rounded-lg p-3 mb-3" data-id="element-233">
          <p className="font-display font-bold text-brand-greenLight uppercase text-xs md:text-sm mb-2 flex items-center gap-1.5" data-id="element-234">
            💎 Guía Premium de Manejo Eficiente
          </p>
          <ul className="space-y-1.5" data-id="element-235">
            {premiumExtras.map((e, i) => <li key={i} className="flex items-start gap-1.5" data-id="element-236">
                <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-greenLight shrink-0 mt-0.5" data-id="element-237" />
                <span className="text-[11px] md:text-xs text-white font-semibold" data-id="element-238">
                  {e}
                </span>
              </li>)}
          </ul>
        </div>

        <p className="text-[11px] md:text-xs text-zinc-400 italic mb-3" data-id="element-239">
          Una guía premium diseñada para productores que buscan trabajar de
          forma más organizada, eficiente y profesional.
        </p>

        <div className="text-center mb-3 mt-auto" data-id="element-240">
          <p className="text-[10px] md:text-xs text-zinc-400 font-bold uppercase mb-0.5" data-id="element-241">
            🔥 Pack completo
          </p>
          <p className="text-3xl md:text-4xl font-display font-bold text-brand-greenLight" data-id="element-242">
            ARS $27.990
          </p>
          <p className="text-[10px] md:text-xs text-zinc-400 mt-0.5" data-id="element-243">
            Pago único · Acceso inmediato a todo
          </p>
        </div>

        <Button href="https://checkout.kitonline.shop/cart/48047349924078:1" pulse={true} className="text-xs md:text-sm py-2.5" data-id="element-244">
          🚀 SÍ, QUIERO EL PACK PREMIUM
        </Button>

        <MercadoPagoBadge data-id="element-245" />

        <div className="flex flex-wrap justify-center gap-2 mt-3 text-[9px] md:text-[10px] text-zinc-400 font-semibold" data-id="element-246">
          <span className="flex items-center gap-0.5" data-id="element-247">
            <Lock className="w-3 h-3 text-brand-greenLight" data-id="element-248" />
            Pago seguro
          </span>
          <span className="flex items-center gap-0.5" data-id="element-249">
            <Zap className="w-3 h-3 text-brand-greenLight" data-id="element-250" />
            Acceso inmediato
          </span>
          <span className="flex items-center gap-0.5" data-id="element-251">
            <ShieldCheck className="w-3 h-3 text-brand-greenLight" data-id="element-252" />
            Garantía 7 días
          </span>
        </div>
      </div>
    </div>;
}
export function PurchaseSection() {
  return <section id="compra" className="py-10 md:py-14 px-4 bg-zinc-950 scroll-mt-6 border-y-2 border-brand-green" data-id="element-253">
      <div className="max-w-5xl mx-auto" data-id="element-254">
        <div className="text-center mb-8" data-id="element-255">
          <div className="inline-block bg-brand-red text-white font-display font-bold px-3.5 py-1 rounded-full mb-3 uppercase tracking-wider text-[11px] md:text-xs shadow-md animate-pulse" data-id="element-256">
            ⏰ El precio de lanzamiento termina en:
          </div>

          <div className="mb-5" data-id="element-257">
            <CountdownTimer data-id="element-258" />
          </div>

          <h2 className="text-2xl md:text-4xl font-display font-bold text-white uppercase leading-tight" data-id="element-259">
            Elegí el plan que mejor{' '}
            <span className="highlight-green" data-id="element-260">se adapta a vos</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto pt-3" data-id="element-261">
          <OfferBlock variant="base" data-id="element-262" />
          <OfferBlock variant="premium" data-id="element-263" />
        </div>
      </div>
    </section>;
}